function getCookie(cookieName) {
  let name = cookieName + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function getSessionId() {
  return getCookie('tb-session-id');
}

function getClientId() {
  return getCookie('tb-client-id');
}

async function generateJwt(fixedParams, pipeName) {
  const jwtEndpoint = 'https://example.com/fetchJWT' // Replace this with the endpoint to generate your JWT
  const response = await fetch(`${jwtEndpoint}?fixed_params=${fixedParams}&pipe_name=${pipeName}`
  );
  if (!response.ok) {
    throw new Error("Failed to generate JWT");
  }
  return response.text();
}

let token = 'p.eyJ1IjogIjJmYzJmZDdlLWJhZDMtNDQxMC05Yjc1LWFkMmZlY2UxYThkNCIsICJpZCI6ICIwZTY4MmYwNi1kYWFiLTRlYTQtYWZjNi1mNTZlYjQ0ZDZiMjQiLCAiaG9zdCI6ICJ1c19lYXN0In0.o4aOMuDoIpmuHoYpbZdLBfW70WTaBvjsDNrD90-KXpk';
const pipeName = 'cart_recommended_products';

document.addEventListener("DOMContentLoaded", async function () {
  const cartDrawer = document.querySelector("cart-drawer");

  /* Generate a JWT when the DOM loads
  try {
    const session_id = getSessionId();
    const client_id = getClientId();
    const fixedParams = {
      session_id: session_id,
      client_id: client_id,
    };
    const encodedParams = encodeURIComponent(JSON.stringify(fixedParams));
    token = await generateJwt(encodedParams, pipeName);
  } catch (error) {
    console.error("Error generating JWT:", error);
  }*/

  if (cartDrawer) {
    // Function to fetch recommended products when cart drawer is opened
    async function handleCartDrawerToggle() {
      // Select the recommendations container
      const recommendationsContainer = document.querySelector(
        ".CartDrawer-RecommendedItems__wrapper"
      );

      // See if there is 1 item in the cart
      if (recommendationsContainer) {
        const cartItem = document.getElementById("CartDrawer-Item-1");
        const productHandle = cartItem.dataset.productHandle;
        const productType = cartItem.dataset.productType;
        const sessionId = getSessionId();
        const clientId = getClientId();

        // Check if the product is a T-Shirt
        const isTShirt = cartItem.dataset.productType === 't-shirt';

        // Get top 3 recommended products from Tinybird API
        const baseApiUrl = `https://api.us-east.tinybird.co/v0/pipes/${pipeName}.json`;
        const params = new URLSearchParams({
          current_product_type: productType.replace(/'/g, ''),
          current_product_handle: productHandle,
          session_id: sessionId,
          client_id: clientId,
          is_t_shirt: isTShirt
        })

        const urlWithParams = `${baseApiUrl}?${params.toString()}`;

        fetch(
          urlWithParams, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        })
          .then((response) => response.json())
          .then((data) => {
            const products = data.data;

            // Add recommended products
            products.forEach((product, index) => {
              const productLink = document.querySelector(`#RecommendedItem${index + 1}`);
              const productImg = productLink.querySelector("img");
              const productTitle = productLink.querySelector(".RecommendedItem__title");

              const handle = product.handle;
              fetch(`/products/${handle}.js`)
                .then((response) => response.json())
                .then((product) => {
                  productLink.href = `${product.url}?ref=cart_rec`;
                  productImg.src = `${product.featured_image}&width=150`;
                  productImg.alt = product.title;
                  productTitle.textContent = product.title;

                  // Remove the hidden class to trigger the fade-in transition
                  productLink.classList.remove("RecommendedItems__hidden");
                });
            });
          })
          .catch((error) =>
            console.error("Error fetching product recommendations:", error)
          );
      }
    }

    // Intercept change calls to account for line item changes
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      if (args[0].includes('/cart/change')) {
        return originalFetch(...args).then(response => {
          const clonedResponse = response.clone();
          clonedResponse.json().then(data => {
            handleCartDrawerToggle();
          });
          return response;
        });
      }
      return originalFetch(...args);
    };

    // Create a MutationObserver to monitor class attribute changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const isActive = cartDrawer.classList.contains("active");
          if (isActive) {
            handleCartDrawerToggle();
          }
        }
      });
    });

    // Start observing the cart drawer element for attribute changes
    observer.observe(cartDrawer, { attributes: true });

    // Optionally, check the initial state in case the cart is already open
    handleCartDrawerToggle();
  } else {
    console.error("Cart drawer element not found");
  }
});